(function($) {
    'use strict';

    class WishlistFlyout {
        constructor() {
            $(document.body).on('click', '.wishlist-link', this.show);
            $(document.body).on('click', '.wishlist-flyout-close', this.hide);

            $(document).on('wishlist/show', this.show);
            $(document).on('wishlist/hide', this.hide);

            $(document.body).on('click', '.wishlist-flyout', function(e) {
                if (e.target !== this) {
                    return;
                }

                $(document.body).trigger('wishlist/hide');
            });
        }

        show = () => {
            $('.wishlist-flyout').addClass('visible');
            $('.action-bar.fixed').addClass('hidden');

            $('body').attr('data-pos', $(window).scrollTop());
            $('html').addClass('flyout--open');
        };

        hide = () => {
            const scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $('.wishlist-flyout-outer')
                .addClass('closed');

            setTimeout(function() {
                $('.wishlist-flyout').removeClass('visible');
                $('.wishlist-flyout-outer')
                    .removeClass('closed');
                $('.action-bar.fixed').removeClass('hidden');
                $('html').removeClass('flyout--open');

                $('.wishlist-share-wrp')
                    .slideToggle()
                    .find('small')
                    .removeClass('wishlist-sent flex items-center gap-x-2 text-sm')
                    .text('Dina favoriter sparas i webbläsaren. Vill du spara dem för att fortsätta handla på en annan dator/mobil kan du skicka dina favoriter i ett mail till dig själv eller till någon annan du vill dela den med.');
                $('.wishlist-share-toggle')
                    .removeClass('active')
                    .text('Dela önskelista');
            }, 500);
        };
    }

    class WishlistHandler {
        constructor() {
            this.flyout = new WishlistFlyout();

            $(document.body)
                .on(
                    'change',
                    '[data-wishlist-product]',
                    this.onToggleWishlistProduct,
                );

            $(document.body).trigger('wishlist', this);

            this.init();
        }

        init = () => {
            if (document.cookie.indexOf('_wID') === -1) {
                return;
            }

            $.ajax({
                url: '/?wc-ajax=wishlist',
                xhrFields: {
                    withCredentials: true,
                },
            }).then(
                response => {
                    this.applyFragments(response.fragments);

                    for (let i = 0, l = response.products.length; i < l; ++i) {
                        $(`[data-wishlist-product="${response.products[i]}"]`)
                            .prop('checked', true);
                    }
                },
            );
        };

        onToggleWishlistProduct = (e) => {
            const $target = $(e.target);
            const id = $target.data('wishlist-product');
            const isHearted = $target.is(':checked');

            const onSuccess = (response) => {
                this.applyFragments(response.fragments);

                const $selector = $(`[data-wishlist-product="${id}"]`);
                $selector.prop('checked', isHearted);
            };

            const onError = () => {

            };

            if (isHearted) {
                this.addToWishlist(id)
                    .then(onSuccess, onError);
            } else {
                this.removeFromWishlist(id)
                    .then(onSuccess, onError);
            }
        };

        applyFragments(fragments) {
            const keys = Object.keys(fragments);
            for (let i = 0, l = keys.length, key; i < l; ++i) {
                key = keys[i];

                $(key).replaceWith(fragments[key]);
            }
        }

        addToWishlist(productId) {
            return $.ajax({
                url: '/?wc-ajax=add_to_wishlist',
                type: 'post',
                data: {
                    product_id: productId,
                },
                xhrFields: {
                    withCredentials: true,
                },
            });
        }

        removeFromWishlist(productId) {
            return $.ajax({
                url: '/?wc-ajax=remove_from_wishlist',
                type: 'post',
                data: {
                    product_id: productId,
                },
                xhrFields: {
                    withCredentials: true,
                },
            });
        }
    }

    new WishlistHandler();

    $(document).on('click', '.wishlist-share-toggle', function(e) {
        e.preventDefault();

        const $self = $(this);
        $self.toggleClass('active');
        $self.prev().slideToggle();
        if ($self.hasClass('active')) {
            $self.text('Stäng');
        } else {
            $self.text('Dela önskelista');
        }
    });

    $(document).on('click', '.wishlist_send', function(e) {
        e.preventDefault();
        const email = $(this).prev().val();
        const $wrapper = $(this).closest('.wishlist-share-wrp');

        if (!isCorrectEmail(email)) {
            $wrapper.prepend(
                '<div class="email-warning basis-full text-sm text-tag-out-of-stock">Du måste ange en e-postadress!</div>');
            $wrapper.find('.email-warning').fadeIn(200);

            setTimeout(function() {
                $('.email-warning').fadeOut(200, function() {
                    $(this).remove();
                });
            }, 2000);

            return;
        }

        $(this).addClass('loading');

        $.ajax({
            type: 'post',
            url: '/?wc-ajax=wishlist_email',
            data: {
                email: email,
            },
            success: function() {
                $('.wishlist_send').removeClass('loading');
                $wrapper.find('small')
                    .addClass('wishlist-sent flex items-center gap-x-2 text-sm')
                    .html('<i class="fas fa-check text-[18px] text-primary"></i> Dina favoriter har skickats till ' + email + '.');
            },
        });

    });

    function isCorrectEmail(email) {
        if (typeof email !== 'string') {
            return false;
        }

        const pattern = new RegExp(
            /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);

        return pattern.test(email);
    }
}(jQuery));
